import { Color, Type } from '@/features/ui/buttons/components/Button/types'
import {
    getBackgroundColor,
    getElementColor,
    getOutlineBorder,
    getShadows,
} from '@/features/ui/buttons/components/Button/utils'
import { ButtonStateEnum } from '@/features/ui/buttons/constants'
import { createStyleSheet } from 'react-native-unistyles'

export const stylesheet = createStyleSheet({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        borderRadius: 4,
        gap: 8,
        variants: {
            size: {
                big: {
                    height: 40,
                    paddingHorizontal: 16,
                },
                medium: {
                    height: 32,
                    paddingHorizontal: 16,
                },
                small: {
                    height: 24,
                    paddingHorizontal: 8,
                },
            },
        },
    },
    extraContainer: (type: Type, state: ButtonStateEnum, color: Color) => ({
        backgroundColor: getBackgroundColor(type, state, color),
        ...(type === 'outline' && getOutlineBorder(state, color)),
        ...(state === ButtonStateEnum.Pressed && getShadows(color)),
    }),
    extraTypography: (type: Type, state: ButtonStateEnum, color: Color) => ({
        color: getElementColor(type, state, color),
    }),
    icon: {
        variants: {
            size: {
                big: {
                    height: 24,
                    width: 24,
                },
                medium: {
                    height: 16,
                    width: 16,
                },
                small: {
                    height: 16,
                    width: 16,
                },
            },
        },
    },
    extraIcon: (type: Type, state: ButtonStateEnum, color: Color) => ({
        color: getElementColor(type, state, color),
    }),
})
